<template>
    <div class="form-field">
        <label>旋转</label>
        <div class="content">
            <el-input size="mini" class="form-input" type="number" :min="-180" :max="180" :step="1" :value="rotate" @focus="setId"
                   @input="setRotate"/>
        </div>
    </div>
</template>

<style lang="scss" scoped>

    .form-input{
        width: 83px;
    }

    .content {
        display: flex;
        > div {
            flex: 1;
            margin-right: 10px;
        }
        > input {
            padding: 0 10px;
        }
    }
</style>

<script>
	export default {
		data() {
			return {
				id: null
			}
		},
		computed: {
			selected() {
				return this.$store.state.selected
			},
			rotate() {
				return this.selected.rotate
			}
		},
		methods: {
			setId() {
				this.id = this.selected.id
			},
			setRotate(value) {
                this.$store.commit('update_elm', {
                	id: this.id,
                    data: {
						rotate: +value
                    }
                })
                this.$store.dispatch('elm_select',{id: this.id})
			}
		}
	}
</script>
